import React from 'react';
import flowers from '../img/flowers_v.png';
import ornament from '../img/ornament.png';
import { Map, Marker } from '@vis.gl/react-google-maps';

const WeddingAgendaSection: React.FC = () => {
  const mapContainerStyle = {
    width: '100%',
    height: '250px',
  };

  const center = {
    lat: 21.000797689012675, // Latitude for Finca La Devocion
    lng: -100.79219952191775, // Longitude for Finca La Devocion
  };
  const markerPosition = {
    lat: 21.000797689012675, // Same latitude as center
    lng: -100.79219952191775, // Same longitude as center
  };
  const handleMarkerClick = () => {
    const googleMapsUrl = `https://maps.app.goo.gl/1saZnuQR6fMpY7qH9`;
    window.open(googleMapsUrl, '_blank'); // Open the link in a new tab
  };

  return (
    <>
      <section
        id="boda"
        className="relative bg-[#B94665] text-center px-16 py-8 lg:px-32"
      >
        {/* Title */}
        <h2 className="text-title text-white">La Boda</h2>
        {/* Separator */}
        <div className="mt-4">
          <img
            src={ornament}
            alt="Ornament"
            className="mx-auto transform scale-x-[1] ornament-size  h-auto "
          />
        </div>
        {/* Wedding Details */}
        <div className="mt-8 text-[#F9DDE3]">
          <p className="italic text-md text-[#FCEEF1]">¿Cuándo?</p>
          <p className="text-lg mt-2 mb-8">15 Marzo 2025</p>
          <p className="italic text-md mt-4 text-[#FCEEF1]">¿A qué hora?</p>
          <p className="text-lg mt-2 mb-8">4:00 PM</p>
          <p className="italic text-md mt-4 text-[#FCEEF1]">¿Dónde?</p>
          <p
            className="text-lg mt-2 mb-8 underline"
            onClick={handleMarkerClick}
          >
            Finca La Devoción
          </p>
          <p className="italic text-md mt-4 text-[#FCEEF1]">
            Código de vestimenta
          </p>
          <p className="text-lg mt-2">Formal</p>
          <p className="mt-2 italic">
            Favor de evitar colores blanco, palo o pasteles
          </p>

          <div className="mt-4 px-10 text-md text-center text-[#F9DDE3]">
            <p className="mt-10">
              Para garantizar una noche tranquila y mágica, nuestra boda será
              solo para adultos.
            </p>
            <p className="mt-10">¡Gracias por comprender!</p>
          </div>
        </div>
        {/* Flowers */}
        <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
          <div
            className="absolute top-0 w-20 h-full m-auto"
            style={{
              backgroundImage: `url(${flowers})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'contain',
            }}
          ></div>
          <div
            className="absolute top-0 right-0 w-20 h-full m-auto -scale-x-100"
            style={{
              backgroundImage: `url(${flowers})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'contain',
            }}
          ></div>
        </div>
      </section>
      <div className="shadow-y-only-inset">
        <Map
          onClick={handleMarkerClick}
          center={center}
          defaultZoom={14}
          style={mapContainerStyle}
        >
          <Marker position={markerPosition} />
        </Map>
      </div>
    </>
  );
};

export default WeddingAgendaSection;
